import { Endpoints } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function usersService($q, apiParamsInitialization, httpService) {
    "ngInject";

    return {
        isAliasChatEligible: false,

        setAliasChat: function (setting) {
            this.isAliasChatEligible = setting;
        },

        getAvatarHeadshots: function (userIds, friendsDict) {
            var avatarMultiGetLimit = 50;
            var avatarUrlConfig = apiParamsInitialization.apiSets.multiGetAvatarHeadshots;

            return httpService.buildBatchPromises(avatarUrlConfig, userIds, avatarMultiGetLimit, "userIds")
                .then(function (data) {
                    if (data && data.length > 0) {
                        var avatars = [];
                        angular.forEach(data, function (item) {
                            avatars = avatars.concat(item.data);
                        });

                        angular.forEach(avatars, function (avatar) {
                            var userId = avatar.targetId;
                            if (!friendsDict[userId]) {
                                friendsDict[userId] = {};
                            }
                            friendsDict[userId].avatarHeadshot = avatar;
                        });
                        return avatars;
                    }
                    return null;
                });
        },

        getUserContacts: function (userIds, friendsDict) {
            var contactsMultiGetLimit = 200;
            var contactsUrlConfig = apiParamsInitialization.apiSets.multiGetContacts;
            if (this.isAliasChatEligible) {
                return httpService.buildBatchPromises(contactsUrlConfig, userIds, contactsMultiGetLimit, "targetUserIds", "POST")
                    .then(function (data) {
                        if (data && data.length > 0) {
                            var contacts = [];
                            angular.forEach(data, function (item) {
                                var contactData = item;
                                contacts = contacts.concat(contactData);
                            });
                            contacts.forEach(function (contact) {
                                var userId = contact.targetUserId;
                                if (!friendsDict[userId]) {
                                    friendsDict[userId] = {};
                                }
                                friendsDict[userId]['contact'] = contact.targetUserTag;
                            });
                            return contacts;
                        }
                        return null;
                    });
            }
        },

        getUserPresence: function (userIds, friendsDict) {
            var presenceMultiGetLimit = 100;
            var presenceUrlConfig = apiParamsInitialization.apiSets.multiGetPresence;

            return httpService.buildBatchPromises(presenceUrlConfig, userIds, presenceMultiGetLimit, "userIds", "POST")
                .then(function (data) {
                    if (data && data.length > 0) {
                        var presences = [];
                        angular.forEach(data, function (item) {
                            var presenceData = item.userPresences;
                            presences = presences.concat(presenceData);
                        });
                        presences.forEach(function (presence) {
                            var userId = presence.userId;
                            if (!friendsDict[userId]) {
                                friendsDict[userId] = {};
                            }
                            friendsDict[userId].presence = presence;
                            if (Endpoints) {
                                friendsDict[userId]['profileUrl'] = Endpoints.generateAbsoluteUrl("/users/{id}/profile", { id: userId }, true);
                            }
                        });

                        return presences;
                    }
                    return null;
                });
        },

        getUserInfo: function (userIds, friendsDict) {
            var returnable = {}
            var promise = {
                avatarHeadshots: this.getAvatarHeadshots(userIds, friendsDict),
                presences: this.getUserPresence(userIds, friendsDict)
            }
            var contacts = this.getUserContacts(userIds, friendsDict);
            return $q.all(promise).then(function (payload) {
                returnable = payload;
               return $q.resolve(contacts, function (secondPayload) {
                    Object.assign(returnable, secondPayload);
                    return returnable;
                }, function () {
                   return returnable;
                });
            });


        }
    }
};


chatModule.factory("usersService", usersService);

export default usersService;